import dayjs from "dayjs";

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export const sortByDate = <T>(
	key: keyof T,
	entities?: T[],
	sortOrder: SortOrder = SortOrder.DESC,
): T[] => {
	return (entities || []).sort((a, b) => {
		const dateA = dayjs(a[key] as unknown as string);
		const dateB = dayjs(b[key] as unknown as string);

		if (sortOrder === SortOrder.DESC) {
			return dateB.isBefore(dateA) ? 1 : -1;
		}
		return dateA.isBefore(dateB) ? 1 : -1;
	});
};
